import { render, staticRenderFns } from "./CatalogueTilePlaceholder.vue?vue&type=template&id=0ba0232a&scoped=true&"
import script from "./CatalogueTilePlaceholder.vue?vue&type=script&lang=js&"
export * from "./CatalogueTilePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueTilePlaceholder.vue?vue&type=style&index=0&id=0ba0232a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0232a",
  null
  
)

export default component.exports